import React from 'react';
import {ViewerEvent} from '../events';
import {mapDefaultProps, MapProps, mapPropTypes, viewerDefaultProps, ViewerProps, viewerPropTypes} from './props';
import connectFull from './connectFull';
import UnconnectedMapViewer from './UnconnectedMapViewer';

/**
 * Mapový zobrazovač (varianta s konfigurací mapy ve store).
 * Interní skrytá implementace.
 *
 * @ignore
 */
const ConnectedMapViewer = connectFull<ViewerProps, ViewerEvent>(UnconnectedMapViewer);

/**
 * Properties mapového zobrazovače (varianta s konfigurací mapy ve store).
 */
export type MapViewerProps = MapProps<ViewerEvent> & ViewerProps;

/**
 * Mapový zobrazovač (varianta s konfigurací mapy ve store).
 *
 * @param props - Properties komponenty.
 * @returns Element.
 */
export default function MapViewer(props: MapViewerProps): JSX.Element {
    return <ConnectedMapViewer debugName="MapViewer" {...props} />;
}

/**
 * Typy properties.
 */
MapViewer.propTypes = {
    ...mapPropTypes,
    ...viewerPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
MapViewer.defaultProps = {
    ...mapDefaultProps,
    ...viewerDefaultProps,
};
